/**
 * 代理相关工具函数
 */

/**
 * 从URL获取agent参数
 * @returns {string|null} agent参数值，如果不存在则返回null
 */
export function getAgentFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('agent') || null
}

/**
 * 将agent参数保存到localStorage
 * @param {string} agentId - agent ID
 */
export function saveAgentToStorage(agentId) {
  if (agentId) {
    localStorage.setItem('currentAgentId', agentId)
  }
}

/**
 * 从localStorage获取agent参数
 * @returns {string|null} agent ID，如果不存在则返回null
 */
export function getAgentFromStorage() {
  return localStorage.getItem('currentAgentId') || null
}

/**
 * 清除localStorage中的agent参数
 */
export function clearAgentFromStorage() {
  localStorage.removeItem('currentAgentId')
}

/**
 * 在路由跳转时保留agent参数
 * @param {string} path - 目标路径
 * @param {object} query - 可选的查询参数对象（用于从路由对象获取）
 * @returns {string} 包含agent参数的完整路径
 */
export function getPathWithAgent(path, query = null) {
  // 优先从传入的 query 参数获取，其次从 URL 获取，最后从 localStorage 获取
  let agentId = null
  if (query && query.agent) {
    agentId = query.agent
  } else {
    agentId = getAgentFromUrl() || getAgentFromStorage()
  }
  
  if (agentId) {
    const separator = path.includes('?') ? '&' : '?'
    return `${path}${separator}agent=${encodeURIComponent(agentId)}`
  }
  return path
}

